/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import FormFader from "@/src/components/Form/Common/Fader/FormFader";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import FormSubmit from "@/src/components/Form/Common/FormSubmit/FormSubmit";
import CheckIcon from "@/src/assets/icons/common/toggleable/IconCheck";
import CrossIcon from "@/src/assets/icons/common/toggleable/IconClose";
import MenuItem from "@mui/material/MenuItem";
import { useForm } from "@/src/provider/Form/FormProvider";
import Group from "@/src/components/Wizard/Group";
import Person from "@/src/components/Form/Common/Person/Person";
import ValidatorSelectField from "@/src/components/FormFields/ValidatorSelectField";
import { requiredValidator } from "@/src/services/validationRules";
import Typography from "@mui/material/Typography";
import FormSubmitProps from "@/src/types/FormSubmitProps";
import wizardStyle from "@/src/components/Form/wizardStyle";
import { Box } from "@mui/material";

type MaintenanceClaimsProps = {
  submitProps: FormSubmitProps;
};

export default function MaintenanceClaims({ submitProps }: MaintenanceClaimsProps) {
  const { values, handleSubmit } = useForm();
  return (
    <Paper sx={wizardStyle.paper} elevation={4}>
      <FormFader>
        <Box component={"form"} sx={wizardStyle.wizardForm} onSubmit={handleSubmit}>
          <Typography variant={"h4"} sx={[wizardStyle.headline, { display: { xs: "block", sm: "none" } }]}>
            Persönliche Angaben
          </Typography>
          <Grid
            container
            sx={{
              justifyContent: "center",
            }}
          >
            <Grid size={12}>
              <Group
                type={"radio"}
                name={"hasAlimonyClaims"}
                question={
                  "Erhalten Sie von jemandem Unterhalt oder steht Ihnen Unterhalt zu? Hierbei geht es nur um Unterhaltszahlungen für Sie persönlich, nicht für Ihre Kinder."
                }
                modalContent={
                  <p>
                    {" "}
                    Bekommen Sie Unterhalt in Form von Zahlungen oder sonstige Leistungen von anderen Personen? Andere Personen können beispielsweise Ehegatten,
                    Lebenspartner, Eltern oder Kinder sein.
                    <br />
                    <strong>Wichtig:</strong> Bitte geben Sie auch "Ja" an, wenn Sie im Moment keine Zahlungen erhalten, Ihnen aber Zahlungen zustehen.
                  </p>
                }
                options={[
                  {
                    labelText: "Nein",
                    labelIcon: <CrossIcon />,
                    labelIconActive: <CrossIcon active />,
                    value: "no",
                  },
                  {
                    labelText: "Ja",
                    labelIcon: <CheckIcon />,
                    labelIconActive: <CheckIcon active />,
                    value: "yes",
                  },
                ]}
                validators={[requiredValidator("Bitte wählen Sie eine der angezeigten Antworten aus")]}
              />
            </Grid>
            {values.hasAlimonyClaims === "yes" && (
              <>
                <Person path="alimonyObligatedPerson" headline="Wie heißt die Person, die Ihnen Unterhalt zahlt oder zahlen müsste?" />
                <Grid size={12}>
                  <ValidatorSelectField
                    label={"Verhältnis zu dieser Person"}
                    name="alimonyObligatedPersonRelation"
                    validators={[requiredValidator("Bitte geben Sie das Verhältnis an")]}
                  >
                    <MenuItem value={"Kind"}>Sie ist mein Kind</MenuItem>
                    <MenuItem value={"Ehepartner"}>Sie ist mein Ehepartner/Expartner</MenuItem>
                    <MenuItem value={"Lebenspartner"}>Sie ist mein Lebenspartner/Expartner</MenuItem>
                    <MenuItem value={"Elternteil"}>Sie ist mein Vater/meine Mutter</MenuItem>
                  </ValidatorSelectField>
                </Grid>
              </>
            )}
          </Grid>
          <FormSubmit {...submitProps} />
        </Box>
      </FormFader>
    </Paper>
  );
}
